import { Box, Grid, styled } from "@mui/material";
import PropertyHeaderForm from "./property-header-form/PropertyHeaderForm";
import AgentsSelector from "./property-steps/description-step/components/agents-selector/AgentsSelector";
import PropertyContainerForm from "./PropertyContainerForm";
import PropertyFooterForm from "./PropertyFooterForm";
import MxFormLayoutMain from "@rf-l1/page/form/MxFormLayoutMain";

export const PropertyBaseContent = () => {
  return (
    <MxFormLayoutMain bgcolor={"background.paper"}>
      <Grid container item xs={12}>
        <Grid item lg={8.5}>
          <PropertyHeaderForm />
        </Grid>

        <Grid
          item
          lg={3.5}
          display={{
            xs: "none",
            lg: "flex"
          }}
        >
          <AgentsSelector />
        </Grid>
      </Grid>

      <Grid
        item
        flex={1}
        display={{
          xs: "flex",
          lg: "none"
        }}
      >
        <AgentsSelector />
      </Grid>

      <Grid item lg={12}>
        <PropertyContainerForm />
      </Grid>

      <Grid item lg={12} position={"relative"}>
        <ContentFooter>
          <PropertyFooterForm />
        </ContentFooter>
      </Grid>
    </MxFormLayoutMain>
  );
};

const ContentFooter = styled(Box)(({}) => ({
  position: "fixed",
  bottom: 0,
  right: 0
}));
